import Vue from "vue";
import VueRouter from "vue-router";

/**
 * 重写路由的push方法，避免重复跳转报错
 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

import Layout from "@/layout/index.vue";

// 空容器组件，用于有子路由但无独立页面的父路由
const RouterViewWrapper = { render: (h) => h("router-view") };

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login.vue"),
    meta: { title: "登录" },
  },
  // AI聊天（独立全屏页面，无顶部导航）
  {
    path: "/ai-chat",
    name: "AiChat",
    component: () => import("../views/ai/AiChat.vue"),
    meta: { title: "AI招聘助手" },
  },
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      // 首页（无二级菜单）
      {
        path: "home",
        name: "Home",
        component: () => import("../views/Home.vue"),
        meta: { hasSubMenu: false },
      },
      // 工作台（有二级菜单）
      {
        path: "workbench",
        name: "Workbench",
        component: RouterViewWrapper,
        redirect: "/workbench/dashboard",
        meta: { hasSubMenu: true },
        children: [
          {
            path: "workOrderCenter",
            name: "WorkOrderCenter",
            component: () => import("../views/workbench/Work-OrderCenter.vue"),
            meta: { title: "订单中心" },
          },
          {
            path: "workInvoice",
            name: "WorkInvoice",
            component: () => import("../views/workbench/Work-Invoice.vue"),
            meta: { title: "开票管理" },
          },
          {
            path: "dashboard",
            name: "Dashboard",
            component: () => import("../views/workbench/Dashboard.vue"),
            meta: { title: "工作台概览" },
          },
          {
            path: "tasks",
            name: "Tasks",
            component: () => import("../views/workbench/Tasks.vue"),
            meta: { title: "我的任务" },
          },
          {
            path: "schedule",
            name: "Schedule",
            component: () => import("../views/workbench/Schedule.vue"),
            meta: { title: "日程安排" },
          },
          {
            path: "prepare",
            name: "Prepare",
            component: () => import("../views/workbench/PrepareView.vue"),
            meta: { title: "制单" },
          },
          // {
          //   path: 'accounting',
          //   name: 'Accounting',
          //   component: () => import('../views/workbench/Accounting.vue'),
          //   meta: { title: '代理记账' }
          // },
          {
            path: "agencyAccount",
            name: "AgencyAccount",
            component: () => import("../views/workbench/AgencyAccount.vue"),
            meta: { title: "代理记账" },
          },
          {
            path: 'entrustedRecruit',
            name: 'EntrustedRecruit',
            component: () => import('../views/workbench/EntrustedRecruit.vue'),
            meta: { title: '委托代招' }
          },

          
        ]
      },
      // 用工管理（有二级菜单）
      {
        path: "employment",
        name: "Employment",
        component: RouterViewWrapper,
        redirect: "/employment/self",
        meta: { hasSubMenu: true },
        children: [
          {
            path: "self",
            name: "SelfEmployee",
            component: () => import("../views/employment/SelfEmployee.vue"),
            meta: { title: "自有员工" },
          },
          {
            path: "flexible",
            name: "FlexibleEmployee",
            component: () => import("../views/employment/FlexibleEmployee.vue"),
            meta: { title: "易匠通用工" },
          },
          {
            path: "partner",
            name: "PartnerMerchant",
            component: () => import("../views/employment/PartnerMerchant.vue"),
            meta: { title: "合作商户" },
          },
          // 劳务派遣/在校兼职/业务外包/非全日制用工/退休返聘
          {
            path: ":type",
            name: "HrmsMember",
            component: () => import("../views/employment/hrmsMember.vue"),
            meta: { title: "用工类型" },
          },
        ],
      },
      // 排班打卡（独立页，无二级菜单）
      {
        path: "schedule-clock",
        name: "ScheduleClock",
        component: () => import("../views/schedule/ScheduleClock.vue"),
        meta: { title: "排班打卡", hasSubMenu: false },
      },
      // 百工市场（独立页，无二级菜单）
      {
        path: "market",
        name: "Market",
        component: () => import("../views/market/Market.vue"),
        meta: { title: "百工市场", hasSubMenu: false },
      },
      // 人员信息详情（独立页，无二级菜单）
      {
        path: "employee-detail/:id",
        name: "EmployeeDetail",
        component: () => import("../views/employment/EmployeeDetail.vue"),
        meta: { title: "人员信息详情", hasSubMenu: false },
      },
      {
        path: "employee-add/:type",
        name: "AddEmployee",
        component: () => import("../views/employment/AddEmployee.vue"),
        meta: { title: "添加人员", hasSubMenu: false },
      },
      // 订单详情（独立页，无二级菜单）
      // 易匠通用工&平台承揽
      {
        path: "order-detail",
        name: "OrderDetail",
        component: () => import("../views/order/OrderDetail.vue"),
        meta: { title: "订单详情", hasSubMenu: false },
      },
      {
        path: "order-detailP",
        name: "OrderDetailP",
        component: () => import("../views/order/OrderDetailP.vue"),
        meta: { title: "订单详情", hasSubMenu: false },
      },
      {
        path: "order-detail-rl",
        name: "OrderDetailRl",
        component: () => import("../views/order/OrderDetailRl.vue"),
        meta: { title: "订单详情", hasSubMenu: false },
      },
      {
        path: "order-detail-own",
        name: "OrderDetailOwn",
        component: () => import("../views/order/OrderDetailOwn.vue"),
        meta: { title: "订单详情", hasSubMenu: false },
      },
      {
        path: "order-detail-flex",
        name: "OrderDetailFlex",
        component: () => import("../views/order/OrderDetails-Flex.vue"),
        meta: { title: "修改订单", hasSubMenu: false },
      },
      {
        path: "invoice-detail-rl",
        name: "InvoiceDetailRl",
        component: () => import("../views/workbench/InvoiceDetailRl.vue"),
        meta: { title: "开票详情", hasSubMenu: false },
      },
      {
        path: "invoice-detail-lp",
        name: "InvoiceDetailLp",
        component: () => import("../views/workbench/InvoiceDetailLp.vue"),
        meta: { title: "开票详情", hasSubMenu: false },
      },
      {
        path: "schedule-detail/:id?",
        name: "ScheduleDetail",
        component: () => import("../views/schedule/ScheduleDetail.vue"),
        meta: { title: "排班管理", hasSubMenu: false },
      },
      // 企业钱包（独立页，无二级菜单）
      {
        path: "wallet",
        name: "Wallet",
        component: () => import("../views/config/Wallet.vue"),
        meta: { title: "企业钱包", hasSubMenu: false },
      },
      // 消息中心（有二级菜单）
      {
        path: "message",
        name: "Message",
        component: RouterViewWrapper,
        redirect: "/message/list",
        meta: { hasSubMenu: true },
        children: [
          {
            path: "list",
            name: "MessageList",
            component: () => import("../views/message/List.vue"),
            meta: { title: "消息列表" },
          },
          {
            path: "notification",
            name: "Notification",
            component: () => import("../views/message/Notification.vue"),
            meta: { title: "系统通知" },
          },
          {
            path: "announcement",
            name: "Announcement",
            component: () => import("../views/message/Announcement.vue"),
            meta: { title: "公告中心" },
          },
        ],
      },
      // 风控中心（有二级菜单）
      {
        path: "risk",
        name: "Risk",
        component: RouterViewWrapper,
        redirect: "/risk/control",
        meta: { hasSubMenu: false },
        children: [
          {
            path: "control",
            name: "RiskControl",
            component: () => import("../views/risk/Control.vue"),
            meta: { title: "风控管理" },
          },
        ],
      },
      // 配置中心（有二级菜单）
      {
        path: "config",
        name: "Config",
        component: RouterViewWrapper,
        redirect: "/config/basic",
        meta: { hasSubMenu: true },
        children: [
          {
            path: "basic",
            name: "BasicConfig",
            component: () => import("../views/config/Basic.vue"),
            meta: { title: "组织管理" },
          },
          {
            path: "service-provider-entity",
            name: "ServiceProviderEntity",
            component: () =>
              import("../views/config/ServiceProviderEntity.vue"),
            meta: { title: "服务商主体" },
          },
          {
            path: "permission",
            name: "Permission",
            component: () => import("../views/config/Permission.vue"),
            meta: { title: "权限管理" },
          },
          {
            path: "system",
            name: "SystemConfig",
            component: () => import("../views/config/System.vue"),
            meta: { title: "系统设置" },
          },
          {
            path: "signing-entity",
            name: "SigningEntity",
            component: () => import("../views/config/SigningEntity.vue"),
            meta: { title: "签约主体" },
          },
          {
            path: "account-management",
            name: "AccountManagement",
            component: () => import("../views/config/AccountManagement.vue"),
            meta: { title: "账户管理" },
          },
        ],
      },
    ],
  },
];

export const publicRoutePaths = [
  "/login",
  "/ai-chat",
  "/workbench/prepare",
  "/schedule-clock",
  "/workbench/agencyAccount",
  "/workbench/entrustedRecruit",
  "/market",
  "/schedule-detail/:id?",
  "/wallet",
  "/workbench/workOrderCenter",
  "/order-detail",
  "/order-detailP",
  "/order-detail-rl",
  "/order-detail-own",
  "/order-detail-flex",
  "/workbench/workInvoice",
];
const publicRouteNames = new Set([
  "Login",
  "AiChat",
  "Prepare",
  "ScheduleClock",
  "AgencyAccount",
  "EntrustedRecruit",
  "Market",
  "ScheduleDetail",
  "Wallet",
  "WorkOrderCenter",
  "OrderDetail",
  "OrderDetailP",
  "OrderDetailRl",
  "OrderDetailOwn",
  "OrderDetailFlex",
  'WorkInvoice',
]);
const auxiliaryRoutePermissions = {
  EmployeeDetail: "/employment",
  AddEmployee: "/employment",
  OrderDetail: "/workbench",
  OrderDetailP: "/workbench",
  OrderDetailRl: "/workbench",
  OrderDetailOwn: "/workbench",
  OrderDetailFlex: "/workbench",
  InvoiceDetailRl: "/workbench",
  InvoiceDetailLp: "/workbench",
  ScheduleDetail: "/schedule-clock",
};

function normalizeMenuTree(menuTree) {
  if (Array.isArray(menuTree)) return menuTree;
  if (typeof menuTree === "string") {
    try {
      const parsed = JSON.parse(menuTree);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }
  return menuTree && typeof menuTree === "object" ? [menuTree] : [];
}

function normalizeMenuKey(value) {
  if (typeof value !== "string" && typeof value !== "number") return "";
  return String(value)
    .trim()
    .replace(/^https?:\/\/[^/]+/i, "")
    .replace(/^#/, "")
    .split("?")[0]
    .replace(/^\/+|\/+$/g, "")
    .toLowerCase();
}

function collectMenuContext(menuTree) {
  const keys = new Set();
  const nodesByKey = new Map();
  const pathNodes = new Map();
  const pathFields = ["path", "component"];
  const valueFields = ["name", "route_name", "menu_name", "title", "label"];
  const childFields = ["children", "child", "child_list", "child_menu", "menus", "menu_list", "menu_children"];

  const addKey = (value, node, isPath = false) => {
    const key = normalizeMenuKey(value);
    if (!key) return;
    keys.add(key);
    if (!nodesByKey.has(key)) nodesByKey.set(key, node);
    if (isPath && !pathNodes.has(key)) pathNodes.set(key, node);
  };

  const visit = (nodes, parentPath = "") => {
    normalizeMenuTree(nodes).forEach(node => {
      if (!node || typeof node !== "object") return;
      let currentPath = parentPath;
      pathFields.forEach(field => {
        const ownPath = normalizeMenuKey(node[field]);
        if (!ownPath) return;
        const fullPath = parentPath && !ownPath.startsWith(`${parentPath}/`)
          ? `${parentPath}/${ownPath}`
          : ownPath;
        addKey(ownPath, node, true);
        addKey(fullPath, node, true);
        if (field === "path") currentPath = fullPath;
      });
      valueFields.forEach(field => addKey(node[field], node));
      childFields.forEach(field => visit(node[field], currentPath));
    });
  };

  visit(menuTree);
  return { keys, nodesByKey, pathNodes };
}

function joinRoutePath(parentPath, routePath) {
  if (routePath.startsWith("/")) return routePath;
  return `${parentPath.replace(/\/$/, "")}/${routePath}`.replace(/\/{2,}/g, "/");
}

function routeMatchesMenu(route, fullPath, menuContext, staticRoutePaths, includePublicRoutes) {
  if (includePublicRoutes && publicRouteNames.has(route.name)) {
    return { matched: true, node: null };
  }

  const candidates = [route.path, fullPath, route.name, route.meta && route.meta.title]
    .map(normalizeMenuKey)
    .filter(Boolean);
  const matchedKey = candidates.find(candidate => menuContext.keys.has(candidate));
  if (matchedKey) return { matched: true, node: menuContext.nodesByKey.get(matchedKey) };

  if (route.path.startsWith(":")) {
    const parentKey = normalizeMenuKey(fullPath.split("/:")[0]);
    const dynamicEntry = Array.from(menuContext.pathNodes.entries()).find(([key]) => (
      key.startsWith(`${parentKey}/`) && !staticRoutePaths.has(key)
    ));
    if (dynamicEntry) return { matched: true, node: dynamicEntry[1] };
  }

  const permissionPath = auxiliaryRoutePermissions[route.name];
  if (!permissionPath) return { matched: false, node: null };
  const permissionKey = normalizeMenuKey(permissionPath);
  const granted = Array.from(menuContext.keys).some(key => key === permissionKey || key.startsWith(`${permissionKey}/`));
  return { matched: granted, node: null };
}

function collectStaticRoutePaths(routeList, parentPath = "/", result = new Set()) {
  routeList.forEach(route => {
    const fullPath = joinRoutePath(parentPath, route.path);
    if (!route.path.startsWith(":")) result.add(normalizeMenuKey(fullPath));
    if (route.children) collectStaticRoutePaths(route.children, fullPath, result);
  });
  return result;
}

function firstLeafPath(route, parentPath = "/") {
  const fullPath = joinRoutePath(parentPath, route.path);
  if (route.children && route.children.length) return firstLeafPath(route.children[0], fullPath);
  return fullPath;
}

function filterRoute(route, parentPath, menuContext, staticRoutePaths, includePublicRoutes = true) {
  const fullPath = joinRoutePath(parentPath, route.path);
  const matchResult = routeMatchesMenu(route, fullPath, menuContext, staticRoutePaths, includePublicRoutes);
  const directMatch = matchResult.matched;
  let children = [];

  if (route.children && route.children.length) {
    children = route.children
      .map(child => filterRoute(child, fullPath, menuContext, staticRoutePaths, includePublicRoutes))
      .filter(Boolean);
    if (directMatch && !children.length) children = route.children.map(child => ({ ...child }));
  }

  if (!directMatch && !children.length) return null;
  const nextRoute = { ...route };
  if (matchResult.node && matchResult.node.meta) {
    nextRoute.meta = {
      ...(route.meta || {}),
      ...matchResult.node.meta,
      menuName: matchResult.node.name,
      iconCls: matchResult.node.iconCls,
      roleId: matchResult.node.roleId,
    };
  }
  if (route.children) {
    nextRoute.children = children;
    if (children.length) nextRoute.redirect = firstLeafPath(children[0], fullPath);
  }
  return nextRoute;
}

function createAuthorizedRouteTable(menuTree) {
  const publicRoutes = routes.filter(route => publicRouteNames.has(route.name));
  const layoutRoute = routes.find(route => route.path === "/");
  const menuContext = collectMenuContext(menuTree);
  if (!layoutRoute) return { routeTable: publicRoutes, entryPath: "/login" };
  const staticRoutePaths = collectStaticRoutePaths(layoutRoute.children);
  const hasMenuEntries = menuContext.keys.size > 0;

  const children = layoutRoute.children
    .map(route => filterRoute(route, "/", menuContext, staticRoutePaths))
    .filter(Boolean);
  if (!hasMenuEntries) {
    const homeRoute = layoutRoute.children.find(route => route.name === "Home");
    if (homeRoute) children.unshift({ ...homeRoute });
  }
  const authorizedChildren = layoutRoute.children
    .map(route => filterRoute(route, "/", menuContext, staticRoutePaths, false))
    .filter(Boolean);

  const entryPath = authorizedChildren.length
    ? firstLeafPath(authorizedChildren[0])
    : hasMenuEntries ? "/login" : "/home";
  return {
    routeTable: publicRoutes.concat({ ...layoutRoute, redirect: entryPath, children }),
    entryPath,
  };
}

export function getStoredMenuTree() {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    return normalizeMenuTree(userInfo.menu_tree);
  } catch (error) {
    return [];
  }
}

function createRouter(routeTable) {
  return new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: routeTable,
  });
}

const initialMenuTree = getStoredMenuTree();
const initialRouteState = createAuthorizedRouteTable(initialMenuTree);
const router = createRouter(initialRouteState.routeTable);
let activeMenuSignature = JSON.stringify(initialMenuTree);
let authorizedEntryPath = initialRouteState.entryPath;

export function syncRoutesFromMenuTree(menuTree = getStoredMenuTree()) {
  const normalizedTree = normalizeMenuTree(menuTree);
  const signature = JSON.stringify(normalizedTree);
  if (signature === activeMenuSignature) return false;

  const nextRouteState = createAuthorizedRouteTable(normalizedTree);
  router.matcher = createRouter(nextRouteState.routeTable).matcher;
  activeMenuSignature = signature;
  authorizedEntryPath = nextRouteState.entryPath;
  return true;
}

export function getAuthorizedEntryPath() {
  return authorizedEntryPath;
}

export default router
